// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__15uKl","item":"PaymentsMobile_item__2OPRJ","label":"PaymentsMobile_label__qXCoN","amount":"PaymentsMobile_amount__3yLBs"};